import axios from 'axios';

export async function downloadFrame(frame) {
  try {
    const { data } = await axios.get(`api/impact_analytics/frames/${frame.id}/download-url/`);
    const a = document.createElement('a');
    a.href = data.url;
    a.download = data.filename || `${String(frame.name || 'frame').replace(/[^a-z0-9]+/gi, '_')}_${frame.id}.csv`;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    return null;
  } catch (err) {
    return err?.response?.status === 403 ? 'Downloading rows needs PHI access.' : 'The download failed.';
  }
}

export async function downloadFrameWorkbook(frame) {
  try {
    const { data } = await axios.post(`api/impact_analytics/frames/${frame.id}/workbook/`);
    const job = await waitForJob(data.job_id);
    if (job.status !== 'completed') {
      return job.error_message || (job.status === 'failed' ? 'The Excel file could not be built.' : 'The Excel file is taking too long; try again shortly.');
    }
    const { data: file } = await axios.get(`api/impact_analytics/frames/${frame.id}/workbook/`, { params: { job: data.job_id } });
    const a = document.createElement('a');
    a.href = file.url;
    a.download = file.filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    const cut = (job.result_data?.sheets || []).some((s) => s.truncated);
    return cut ? 'Excel holds at most 1,048,575 rows a sheet; the file was cut there. Download CSV for every row.' : null;
  } catch (err) {
    return err?.response?.status === 403 ? 'Downloading rows needs PHI access.' : 'The download failed.';
  }
}

export async function waitForJob(jobId, ticket = null, { every = 1500, limit = 400 } = {}) {
  let job = { status: 'pending' };
  for (let i = 0; i < limit && (!ticket || ticket.active) && ['pending', 'in_progress'].includes(job.status); i += 1) {
    await new Promise((resolve) => { setTimeout(resolve, every); });
    job = (await axios.get(`api/jobs/${jobId}/status/`)).data;
  }
  return job;
}
